import { render, staticRenderFns } from "./kartu-piutang.vue?vue&type=template&id=81fa3a74"
import script from "./kartu-piutang.vue?vue&type=script&lang=js"
export * from "./kartu-piutang.vue?vue&type=script&lang=js"
import style0 from "./kartu-piutang.vue?vue&type=style&index=0&id=81fa3a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports